export default "__VITE_ASSET__MFMZItBJ__"